/* tslint:disable */
/* eslint-disable */
/**
 * mindd-patient-api-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Agreement } from '../model';
// @ts-ignore
import type { AgreementCreateRequest } from '../model';
// @ts-ignore
import type { AgreementDispatch } from '../model';
// @ts-ignore
import type { AgreementType } from '../model';
// @ts-ignore
import type { OptionalAgreementCreateRequest } from '../model';
// @ts-ignore
import type { OrgConsentStatusRow } from '../model';
/**
 * AgreementControllerApi - axios parameter creator
 * @export
 */
export const AgreementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Agreement 생성
         * @param {OptionalAgreementCreateRequest} [optionalAgreementCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (optionalAgreementCreateRequest?: OptionalAgreementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(optionalAgreementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 선택항목 Agreement 생성, 토큰 가진 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} patientId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOptional: async (patientId: string, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('createOptional', 'patientId', patientId)
            // verify required parameter 'optionalAgreementCreateRequest' is not null or undefined
            assertParamExists('createOptional', 'optionalAgreementCreateRequest', optionalAgreementCreateRequest)
            const localVarPath = `/api/v1/agreements/optional`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(optionalAgreementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Agreement 삭제
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1: async (agreementId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('delete1', 'agreementId', agreementId)
            const localVarPath = `/api/v1/agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 동의서 조회
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [patientIds] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll: async (ids?: Array<string>, patientIds?: Array<string>, orgIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (patientIds) {
                localVarQueryParameter['patientIds'] = patientIds;
            }

            if (orgIds) {
                localVarQueryParameter['orgIds'] = orgIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 기본은 기한이 남아 있고 아직 동의하지 않은 발송 건입니다. 기관은 토큰에서 읽으며 요청으로 지정할 수 없습니다. 환자명·차트번호는 싣지 않으므로 웹이 환자 목록과 patientId 로 조합합니다. 한 종류만 보려면 agreementType 을 지정해야 합니다. 생략하면 그 기관의 모든 종류가 섞여 나오므로, 응답 개수를 그대로 지표로 쓰는 화면은 종류를 지정하지 않으면 숫자가 틀립니다.
         * @summary 동의서 발송 기록 조회
         * @param {AgreementType} [agreementType] 
         * @param {string} [expiresAfter] 해당 시점에 만료되지 않은 것만 조회합니다. 기본값은 현재 시각입니다. 형식은 ISO-8601 (예: 2026-08-05T15:00:00Z 또는 2026-08-06T00:00:00+09:00)
         * @param {boolean} [pendingOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDispatches: async (agreementType?: AgreementType, expiresAfter?: string, pendingOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements/dispatches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (agreementType !== undefined) {
                localVarQueryParameter['agreementType'] = agreementType;
            }

            if (expiresAfter !== undefined) {
                localVarQueryParameter['expiresAfter'] = (expiresAfter as any instanceof Date) ?
                    (expiresAfter as any).toISOString() :
                    expiresAfter;
            }

            if (pendingOnly !== undefined) {
                localVarQueryParameter['pendingOnly'] = pendingOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 환자별 동의서 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPatientAgreements: async (patientId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('findPatientAgreements', 'patientId', patientId)
            const localVarPath = `/api/v1/agreements/{patientId}`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자에게 보여줄 동의서 URL을 생성합니다. 아직 내부 구현 전 단계이며, 요청 바디에는 URL에 포함할 동의 항목 목록을 전달해야 합니다.
         * @summary Patient agreement URL 생성
         * @param {string} patientId 동의서 URL을 생성할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrl: async (patientId: string, agreementCreateRequest: AgreementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('getUrl', 'patientId', patientId)
            // verify required parameter 'agreementCreateRequest' is not null or undefined
            assertParamExists('getUrl', 'agreementCreateRequest', agreementCreateRequest)
            const localVarPath = `/api/v1/agreements/{patientId}/url`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 오늘(KST) 최초 동의 완료(PATIENT_REGISTRATION)한 환자 목록. 환자명/차트번호/성별은 웹이 환자목록과 patientId 로 조합.
         * @summary org(병원) 오늘 동의완료 현황
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/agreements/org-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 환자에게 동의서 발송을 요청하는 API입니다.
         * @summary Patient agreement 발송
         * @param {string} patientId 동의서를 발송할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (patientId: string, agreementCreateRequest: AgreementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('send', 'patientId', patientId)
            // verify required parameter 'agreementCreateRequest' is not null or undefined
            assertParamExists('send', 'agreementCreateRequest', agreementCreateRequest)
            const localVarPath = `/api/v1/agreements/{patientId}/send`
                .replace(`{${"patientId"}}`, encodeURIComponent(String(patientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Public] 선택항목 Agreement 생성, QR Code 를 통해 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {string} patientId 
         * @param {number} orgId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndCreateOptional: async (code: string, patientId: string, orgId: number, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyAndCreateOptional', 'code', code)
            // verify required parameter 'patientId' is not null or undefined
            assertParamExists('verifyAndCreateOptional', 'patientId', patientId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('verifyAndCreateOptional', 'orgId', orgId)
            // verify required parameter 'optionalAgreementCreateRequest' is not null or undefined
            assertParamExists('verifyAndCreateOptional', 'optionalAgreementCreateRequest', optionalAgreementCreateRequest)
            const localVarPath = `/api/v1/agreements/optional/body`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(optionalAgreementCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementControllerApi - functional programming interface
 * @export
 */
export const AgreementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Agreement 생성
         * @param {OptionalAgreementCreateRequest} [optionalAgreementCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(optionalAgreementCreateRequest?: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(optionalAgreementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 선택항목 Agreement 생성, 토큰 가진 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} patientId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOptional(patientId: string, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOptional(patientId, optionalAgreementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.createOptional']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Agreement 삭제
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async delete1(agreementId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.delete1(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.delete1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 동의서 조회
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [patientIds] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAll(ids?: Array<string>, patientIds?: Array<string>, orgIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAll(ids, patientIds, orgIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.findAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 기본은 기한이 남아 있고 아직 동의하지 않은 발송 건입니다. 기관은 토큰에서 읽으며 요청으로 지정할 수 없습니다. 환자명·차트번호는 싣지 않으므로 웹이 환자 목록과 patientId 로 조합합니다. 한 종류만 보려면 agreementType 을 지정해야 합니다. 생략하면 그 기관의 모든 종류가 섞여 나오므로, 응답 개수를 그대로 지표로 쓰는 화면은 종류를 지정하지 않으면 숫자가 틀립니다.
         * @summary 동의서 발송 기록 조회
         * @param {AgreementType} [agreementType] 
         * @param {string} [expiresAfter] 해당 시점에 만료되지 않은 것만 조회합니다. 기본값은 현재 시각입니다. 형식은 ISO-8601 (예: 2026-08-05T15:00:00Z 또는 2026-08-06T00:00:00+09:00)
         * @param {boolean} [pendingOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findDispatches(agreementType?: AgreementType, expiresAfter?: string, pendingOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgreementDispatch>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findDispatches(agreementType, expiresAfter, pendingOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.findDispatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 환자별 동의서 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findPatientAgreements(patientId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findPatientAgreements(patientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.findPatientAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자에게 보여줄 동의서 URL을 생성합니다. 아직 내부 구현 전 단계이며, 요청 바디에는 URL에 포함할 동의 항목 목록을 전달해야 합니다.
         * @summary Patient agreement URL 생성
         * @param {string} patientId 동의서 URL을 생성할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUrl(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUrl(patientId, agreementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.getUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 오늘(KST) 최초 동의 완료(PATIENT_REGISTRATION)한 환자 목록. 환자명/차트번호/성별은 웹이 환자목록과 patientId 로 조합.
         * @summary org(병원) 오늘 동의완료 현황
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrgConsentStatusRow>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.orgStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 환자에게 동의서 발송을 요청하는 API입니다.
         * @summary Patient agreement 발송
         * @param {string} patientId 동의서를 발송할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(patientId, agreementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.send']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Public] 선택항목 Agreement 생성, QR Code 를 통해 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {string} patientId 
         * @param {number} orgId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyAndCreateOptional(code: string, patientId: string, orgId: number, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyAndCreateOptional(code, patientId, orgId, optionalAgreementCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.verifyAndCreateOptional']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementControllerApi - factory interface
 * @export
 */
export const AgreementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Agreement 생성
         * @param {OptionalAgreementCreateRequest} [optionalAgreementCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(optionalAgreementCreateRequest?: OptionalAgreementCreateRequest, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.create(optionalAgreementCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 선택항목 Agreement 생성, 토큰 가진 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} patientId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOptional(patientId: string, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.createOptional(patientId, optionalAgreementCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Agreement 삭제
         * @param {string} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delete1(agreementId: string, options?: any): AxiosPromise<void> {
            return localVarFp.delete1(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 동의서 조회
         * @param {Array<string>} [ids] 
         * @param {Array<string>} [patientIds] 
         * @param {Array<number>} [orgIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAll(ids?: Array<string>, patientIds?: Array<string>, orgIds?: Array<number>, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.findAll(ids, patientIds, orgIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 기본은 기한이 남아 있고 아직 동의하지 않은 발송 건입니다. 기관은 토큰에서 읽으며 요청으로 지정할 수 없습니다. 환자명·차트번호는 싣지 않으므로 웹이 환자 목록과 patientId 로 조합합니다. 한 종류만 보려면 agreementType 을 지정해야 합니다. 생략하면 그 기관의 모든 종류가 섞여 나오므로, 응답 개수를 그대로 지표로 쓰는 화면은 종류를 지정하지 않으면 숫자가 틀립니다.
         * @summary 동의서 발송 기록 조회
         * @param {AgreementType} [agreementType] 
         * @param {string} [expiresAfter] 해당 시점에 만료되지 않은 것만 조회합니다. 기본값은 현재 시각입니다. 형식은 ISO-8601 (예: 2026-08-05T15:00:00Z 또는 2026-08-06T00:00:00+09:00)
         * @param {boolean} [pendingOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findDispatches(agreementType?: AgreementType, expiresAfter?: string, pendingOnly?: boolean, options?: any): AxiosPromise<Array<AgreementDispatch>> {
            return localVarFp.findDispatches(agreementType, expiresAfter, pendingOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 환자별 동의서 조회
         * @param {string} patientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findPatientAgreements(patientId: string, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.findPatientAgreements(patientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 환자에게 보여줄 동의서 URL을 생성합니다. 아직 내부 구현 전 단계이며, 요청 바디에는 URL에 포함할 동의 항목 목록을 전달해야 합니다.
         * @summary Patient agreement URL 생성
         * @param {string} patientId 동의서 URL을 생성할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrl(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.getUrl(patientId, agreementCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 오늘(KST) 최초 동의 완료(PATIENT_REGISTRATION)한 환자 목록. 환자명/차트번호/성별은 웹이 환자목록과 patientId 로 조합.
         * @summary org(병원) 오늘 동의완료 현황
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgStatus(options?: any): AxiosPromise<Array<OrgConsentStatusRow>> {
            return localVarFp.orgStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 환자에게 동의서 발송을 요청하는 API입니다.
         * @summary Patient agreement 발송
         * @param {string} patientId 동의서를 발송할 대상 Patient ID
         * @param {AgreementCreateRequest} agreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.send(patientId, agreementCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Public] 선택항목 Agreement 생성, QR Code 를 통해 환자 생성 시 선택항목 동의서 생성에 사용됨
         * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
         * @param {string} patientId 
         * @param {number} orgId 
         * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyAndCreateOptional(code: string, patientId: string, orgId: number, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.verifyAndCreateOptional(code, patientId, orgId, optionalAgreementCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementControllerApi - object-oriented interface
 * @export
 * @class AgreementControllerApi
 * @extends {BaseAPI}
 */
export class AgreementControllerApi extends BaseAPI {
    /**
     * 
     * @summary Agreement 생성
     * @param {OptionalAgreementCreateRequest} [optionalAgreementCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public create(optionalAgreementCreateRequest?: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).create(optionalAgreementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 선택항목 Agreement 생성, 토큰 가진 환자 생성 시 선택항목 동의서 생성에 사용됨
     * @param {string} patientId 
     * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public createOptional(patientId: string, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).createOptional(patientId, optionalAgreementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Agreement 삭제
     * @param {string} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public delete1(agreementId: string, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).delete1(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 동의서 조회
     * @param {Array<string>} [ids] 
     * @param {Array<string>} [patientIds] 
     * @param {Array<number>} [orgIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public findAll(ids?: Array<string>, patientIds?: Array<string>, orgIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).findAll(ids, patientIds, orgIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 기본은 기한이 남아 있고 아직 동의하지 않은 발송 건입니다. 기관은 토큰에서 읽으며 요청으로 지정할 수 없습니다. 환자명·차트번호는 싣지 않으므로 웹이 환자 목록과 patientId 로 조합합니다. 한 종류만 보려면 agreementType 을 지정해야 합니다. 생략하면 그 기관의 모든 종류가 섞여 나오므로, 응답 개수를 그대로 지표로 쓰는 화면은 종류를 지정하지 않으면 숫자가 틀립니다.
     * @summary 동의서 발송 기록 조회
     * @param {AgreementType} [agreementType] 
     * @param {string} [expiresAfter] 해당 시점에 만료되지 않은 것만 조회합니다. 기본값은 현재 시각입니다. 형식은 ISO-8601 (예: 2026-08-05T15:00:00Z 또는 2026-08-06T00:00:00+09:00)
     * @param {boolean} [pendingOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public findDispatches(agreementType?: AgreementType, expiresAfter?: string, pendingOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).findDispatches(agreementType, expiresAfter, pendingOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 환자별 동의서 조회
     * @param {string} patientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public findPatientAgreements(patientId: string, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).findPatientAgreements(patientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자에게 보여줄 동의서 URL을 생성합니다. 아직 내부 구현 전 단계이며, 요청 바디에는 URL에 포함할 동의 항목 목록을 전달해야 합니다.
     * @summary Patient agreement URL 생성
     * @param {string} patientId 동의서 URL을 생성할 대상 Patient ID
     * @param {AgreementCreateRequest} agreementCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public getUrl(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).getUrl(patientId, agreementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 오늘(KST) 최초 동의 완료(PATIENT_REGISTRATION)한 환자 목록. 환자명/차트번호/성별은 웹이 환자목록과 patientId 로 조합.
     * @summary org(병원) 오늘 동의완료 현황
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public orgStatus(options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).orgStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 환자에게 동의서 발송을 요청하는 API입니다.
     * @summary Patient agreement 발송
     * @param {string} patientId 동의서를 발송할 대상 Patient ID
     * @param {AgreementCreateRequest} agreementCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public send(patientId: string, agreementCreateRequest: AgreementCreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).send(patientId, agreementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Public] 선택항목 Agreement 생성, QR Code 를 통해 환자 생성 시 선택항목 동의서 생성에 사용됨
     * @param {string} code 프론트엔드와 검증하기 위한 code 로 보임
     * @param {string} patientId 
     * @param {number} orgId 
     * @param {OptionalAgreementCreateRequest} optionalAgreementCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public verifyAndCreateOptional(code: string, patientId: string, orgId: number, optionalAgreementCreateRequest: OptionalAgreementCreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).verifyAndCreateOptional(code, patientId, orgId, optionalAgreementCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

